import React from 'react'
import Logo from '../../images/superrewards-logo.svg'

const Image = (props) => <img alt="SuperRewards Logo" src={Logo} {...props} />

export default Image
